import { render, staticRenderFns } from "./apis.vue?vue&type=template&id=f05f19d2&scoped=true"
import script from "./apis.vue?vue&type=script&lang=js"
export * from "./apis.vue?vue&type=script&lang=js"
import style0 from "./apis.vue?vue&type=style&index=0&id=f05f19d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05f19d2",
  null
  
)

export default component.exports